import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { FederalAssistanceDoc, federalDefaults, FA_CSS } from "@/pages/FederalAssistanceGrant";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public, token-signed print route for headless-Chrome PDF rendering / eFax.
export default function PrintFederalAssistance() {
  const { appId } = useParams();
  const t = new URLSearchParams(useLocation().search).get("t");
  const [app, setApp] = useState(null);
  const [shared, setShared] = useState(null);

  useEffect(() => {
    if (!appId || !t) return;
    (async () => {
      try {
        const r = await axios.get(`${API}/borrower/applications/${appId}/public?t=${encodeURIComponent(t)}`);
        const a = r.data.application || {};
        const saved = a.federal_assistance_settings || {};
        setShared({ ...federalDefaults(), ...saved });
        setApp(a);
      } catch { /* leave blank */ }
    })();
  }, [appId, t]);

  if (!app || !shared) return <div style={{ padding: 40, fontFamily: "serif" }}>Loading…</div>;
  return (
    <div style={{ background: "#fff" }}>
      <div className="cm-print-area">
        <FederalAssistanceDoc app={app} shared={shared} last />
      </div>
      <style>{FA_CSS}</style>
    </div>
  );
}
